import { useState } from 'react';
import { isSuperAdmin } from '../auth';

export default function Sidebar({ collapsed, onToggleCollapse, projects, selectedProject, onSelectProject, onNewProject, onShowMembers, onShowAdmin, showingAdmin, showingMembers, onShowProjects, showingProjects }) {
  const [projectsOpen, setProjectsOpen] = useState(false);
  const isAdmin = isSuperAdmin();

  return (
    <div className={`app-sidebar${collapsed ? ' collapsed' : ''}`}>
      {/* Logo — always shows icon, label only when expanded */}
      <div className="sidebar-logo">
        <span style={{ fontSize: 22, flexShrink: 0 }}>💰</span>
        {!collapsed && <span className="sidebar-logo-text">DuesTrack</span>}
      </div>

      <nav className="sidebar-nav">

        {/* Super Admin section */}
        {isAdmin && (
          <>
            {!collapsed && <div className="sidebar-section-label">Admin</div>}
            <button
              className={`sidebar-item${showingAdmin ? ' active' : ''}`}
              title="Admin Panel"
              onClick={onShowAdmin}>
              <span className="sidebar-icon">🛡</span>
              <span className="sidebar-label">Admin Panel</span>
            </button>
            <div className="sidebar-divider" />
          </>
        )}

        {/* Projects */}
        {!collapsed && <div className="sidebar-section-label">Organization</div>}

        <div style={{ display: 'flex', alignItems: 'center' }}>
          {/* Navigate to projects */}
          <button
            className={`sidebar-item${showingProjects ? ' active' : ''}`}
            title="Projects"
            style={{ flex: 1 }}
            onClick={onShowProjects}>
            <span className="sidebar-icon">📁</span>
            <span className="sidebar-label">Projects</span>
          </button>
          {/* Toggle sub-menu — separate from navigation */}
          {!collapsed && (
            <button
              onClick={() => setProjectsOpen(o => !o)}
              style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px 10px', color: 'var(--muted)', fontSize: 12 }}
              title={projectsOpen ? 'Collapse' : 'Expand'}>
              {projectsOpen ? '▾' : '▸'}
            </button>
          )}
        </div>

        {/* Project sub-items */}
        {projectsOpen && !collapsed && projects.map(p => (
          <button
            key={p.projectId}
            className={`sidebar-sub-item${selectedProject?.projectId === p.projectId ? ' active' : ''}`}
            onClick={() => { onSelectProject(p); }}>
            <span style={{ fontSize: 12 }}>▸</span>
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.name}</span>
          </button>
        ))}

        {projectsOpen && !collapsed && (
          <button className="sidebar-sub-item" onClick={onNewProject} style={{ color: 'var(--navy)' }}>
            <span style={{ fontSize: 12 }}>+</span>
            <span>New Project</span>
          </button>
        )}

        <div className="sidebar-divider" />

        {/* Team */}
        <button
          className={`sidebar-item${showingMembers ? ' active' : ''}`}
          title="Team Members"
          onClick={onShowMembers}>
          <span className="sidebar-icon">👥</span>
          <span className="sidebar-label">Team Members</span>
        </button>

      </nav>

      {/* Minimize / Maximize button — always at the bottom */}
      <div style={{ borderTop: '1px solid var(--border)', padding: '10px 12px' }}>
        <button className="sidebar-item" onClick={onToggleCollapse}
          style={{ width: '100%', borderRadius: 6, color: 'var(--muted)', fontSize: 13 }}
          title={collapsed ? 'Expand sidebar' : 'Minimize sidebar'}>
          <span className="sidebar-icon" style={{ fontSize: 14 }}>{collapsed ? '›' : '‹'}</span>
          <span className="sidebar-label">Minimize</span>
        </button>
      </div>
    </div>
  );
}
